import React from 'react'
import {useTranslation} from 'react-i18next'
import {FaChevronDown as ChevronDown, FaChevronUp as ChevronUp} from 'react-icons/fa'
import dayjs from '@helpers/dayjs'
import {isPaymentComplete} from '@helpers/websites/tableOrders'
import {useState} from '@hooks/useState'
import FormatNumber from '@i18n/formatNumber/Component'

import Status from './Status'

import styles from './styles.module.css'

export interface OrdersProps {
  count?: number
  total?: number
  user?: any
  orders?: any[]
}

export default function Orders(props: OrdersProps) {
  const {user = {}, orders = [], count = 0, total = 0} = props
  const [isActive, setIsActive] = useState(false)
  const {t} = useTranslation('website', {keyPrefix: 'order.cart.content.resume'})
  const unpaidOrdersTotal = orders
    .filter(order => !isPaymentComplete(order))
    .reduce((previousValue, currentValue) => {
      return previousValue + currentValue.amountToPay
    }, 0)

  return (
    <div className={styles.container} onClick={() => setIsActive(!isActive)}>
      <div className={styles.order}>
        <div className={styles.left}>
          <h4>{user.profile.firstName}</h4>
          <h5 className={styles.h5}>({count})</h5>
        </div>
        <div className={styles.right}>
          <div className={styles.chevron}>
            {isActive ? (
              <>
                {t('labelShowless')}
                <ChevronUp className={styles.icon} />
              </>
            ) : (
              <>
                {t('labelShowMore')} <ChevronDown className={styles.icon} />
              </>
            )}
          </div>
        </div>
      </div>
      {isActive ? (
        <div className={styles.containerItems}>
          {orders.map(order =>
            order.items.map(item => (
              <div key={item._id} className={styles.containerItem}>
                <div className={styles.itemAmount}>{item.amount}</div>
                <div className={styles.itemName}>
                  {item.product.name}
                  <div className={styles.date}>{dayjs(order.createdAt).format('HH:mm')}hrs.</div>
                </div>
                <div className={styles.containerItemsPrice}>
                  <h4 className={styles.itemUnitPrice}>
                    <FormatNumber value={item.unitPrice * item.amount} />
                  </h4>
                  <Status order={order} />
                </div>
              </div>
            ))
          )}
        </div>
      ) : null}
      <div className={styles.orderGroup}>
        <h4 className={styles.totalOrderPrice}>
          {unpaidOrdersTotal > 0 ? (
            <FormatNumber
              value={unpaidOrdersTotal}
              render={number => <>{`Por pagar: ${number}`}</>}
            />
          ) : (
            <Status order={orders[0]} />
          )}
        </h4>
        <h4 className={styles.totalOrderPrice}>
          <strong>
            Total: <FormatNumber value={total} />
          </strong>
        </h4>
      </div>
    </div>
  )
}
